import React from 'react'
import './AdminHeader.css'

const AdminHeader = (props) => {
	return <header className='admin-header'>{props.children}</header>
}

export default AdminHeader
